declare var require: any;

import {Environment} from './environment.model';

// Note: this file is used for dev/beta builds.

// Pipeline note:
// Dev/Beta
// `build-beta-image` and `build-dev-image-from-master` use this file because they
// run `ng build --configuration production` without copying env files.
// Prod/pre-prod
// images overwrite this file with `environment.online.ts` before building.
export const environment: Environment = {
  production: true,
  ekulturPrimusAppID: '06571733-ed99-4a83-92bf-78e64236938a',
  ekulturLoginGatewayURL: 'https://beta-login.ekultur.org',
  ekulturAPIGatewayURL: 'https://beta-apigateway.primus.org',
  plausible: {
    domain: 'beta.primus.org',
  },
  version: require('../../package.json').version
};
